/**
 * Topbar
 * Purpose: Top bar with page title, year selector and the notification bell
 * (components/notifications, 10/11/26 - every signed-in person who is not
 * pending; the server filters what each one sees).
 */
import { PAGE_TITLES } from '../../data/navigation';
import { YearPicker } from './YearPicker';
import { ComparePicker } from './ComparePicker';
import { useAuth } from '../../context/AuthContext';
import { useApp } from '../../context/AppContext';
import { isAdminUser, getRole } from '../../data/admins';
import { useMyAccess } from '../../hooks/useMyAccess';
import NotificationBell from '../notifications/NotificationBell';

export const Topbar = ({ active }) => {
  const title = PAGE_TITLES[active] || '';
  const { user, signOut } = useAuth();
  const { users } = useApp();
  const access = useMyAccess();
  const amAdmin = isAdminUser(user?.email, users);
  // Engineers' tabs (schedule / project / reports / SVM) aren't year-filtered —
  // hide the picker for them entirely.
  const isEngineer = getRole(user?.email, users) === 'engineer';
  // The Leads Dashboard picks its own period and the Tasks page its own due
  // window; a year picker there would contradict them.
  const ownDates = active === 'leads-dashboard' || active === 'tasks';

  return (
    <header className="h-16 px-7 flex items-center justify-between border-b border-border bg-surface shrink-0">
      <div className="flex items-center gap-4">
        <h1 className="text-h2 m-0 font-display text-gat-greenDarkest">{title}</h1>
      </div>
      <div className="flex items-center gap-2">
        {active === 'dashboard' && <ComparePicker />}
        {!isEngineer && !ownDates && <YearPicker />}
        {user && access && access.role !== 'pending' && <NotificationBell />}
        {user && (
          <div className="flex items-center gap-2 pl-3 ml-2 border-l border-border">
            {/* Email is noise on a phone — show from md up. */}
            <span className="hidden md:inline text-xs text-gray-500">{user.email}</span>
            {amAdmin && <span className="px-1.5 py-0.5 text-[10px] font-semibold rounded-full bg-green-100 text-green-800">ADMIN</span>}
            <button
              onClick={signOut}
              className="ml-1 px-3 py-1 text-xs font-medium rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700 transition-colors"
              title="Sign out"
            >
              Sign out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
